export default "__VITE_ASSET__BtYfgFjl__"